import { Component } from '@angular/core';

@Component({
  templateUrl: '404.component.html'
})
export class P404Component {

  constructor() { }
  goBack() {
    if (window.history.length > 1) {
      window.history.back(); // Go back if history exists
    } else {
      window.close(); // Close tab if no history
    }
  }
}
